/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Disp_Sub_Items_HintInputs */

const en_disp_sub_items_hint = /** @type {(inputs: Disp_Sub_Items_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nest sub-items under their parent. Off hides them.`)
};

const de_disp_sub_items_hint = /** @type {(inputs: Disp_Sub_Items_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untervorgänge unter ihrem übergeordneten Vorgang einrücken. Aus blendet sie aus.`)
};

/**
* | output |
* | --- |
* | "Nest sub-items under their parent. Off hides them." |
*
* @param {Disp_Sub_Items_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const disp_sub_items_hint = /** @type {((inputs?: Disp_Sub_Items_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Disp_Sub_Items_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_disp_sub_items_hint(inputs)
	return en_disp_sub_items_hint(inputs)
});